/**
 * CENTRAL API UTILITY — All API calls MUST go through this module.
 * 
 * NEVER use raw fetch() with credentials: 'include' anywhere in this app.
 * Auth uses Bearer tokens from localStorage, NOT cookies.
 * This was broken TWICE by credentials: 'include' on cross-origin requests
 * from the custom domain (elevatingmn.org) to the preview backend.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const getToken = () => localStorage.getItem('elevatemn_session');

/**
 * Authenticated fetch — automatically attaches Bearer token.
 * NEVER sends credentials: 'include' (breaks custom domain cross-origin).
 */
export const apiFetch = async (path, options = {}) => {
  const token = getToken();
  const headers = {
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...(options.headers || {})
  };

  // Strip credentials if accidentally passed — this is the guard
  const { credentials, ...safeOptions } = options;

  return fetch(path.startsWith('http') ? path : `${API_BASE}${path}`, {
    ...safeOptions,
    headers,
  });
};

/**
 * Public fetch — no auth token, no credentials.
 */
export const publicFetch = (path, options = {}) => {
  const { credentials, ...safeOptions } = options;
  return fetch(path.startsWith('http') ? path : `${API_BASE}${path}`, safeOptions);
};

export const clearSession = () => localStorage.removeItem('elevatemn_session');
export const setSession = (token) => localStorage.setItem('elevatemn_session', token);
export const hasSession = () => !!getToken();
